import { Button, Checkbox, Container, Form, FormField, Input, RadioGroup, SelectProps, Spinner, Textarea } from '@cloudscape-design/components';
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import Header from '@cloudscape-design/components/header';
import SpaceBetween from '@cloudscape-design/components/space-between';
import React, { useEffect, useState } from 'react';
import {
    addNotification,
    addNotificationStatus,
    buildBreadcrumbItems,
    getCookie,
    getUrlVersion,
    isEmail,
    setData,
    setLoading
} from '../../../../commons/functions';
import { useGlobalState } from '../../../../context/GlobalStateContext';
import { CustomAppLayout } from '../../../layout';
const _preserve = React.version;
//import { useStoreAdmin } from '../../../../context/useStoreAdmin';

import { formatRut, validateRut } from '@fdograph/rut-utilities';
import { format } from 'date-fns';
import CurrencyInput from '../../../../../components/CurrencyInput';
import Favorites from '../../../../../components/extras/Favorites';
import PhoneInput from '../../../../../components/PhoneInput';
import SelectAccountPlan from '../../../../../components/selects/selectAccountPlans';
import SelectUser from '../../../../../components/selects/selectUser';
import { fetchWithWatch } from '../../../../../hooks/fetchWithWatch';
import { ItemsMovement } from '../../../../../resources/types';

const pageSize = 20;
type OptionDefinition = SelectProps.Option;

export const OPSMercenariesVouchersAddPage = () => {
    const { data, menu } = useGlobalState();
    const [movement, setMovement] = useState<ItemsMovement>();
    const [rutLoading, setRutLoading] = useState<boolean>(false);
    const handleRUTBlur = () => {
        if (validateRut(movement?.jsonMovement?.rut ?? "")) {
            handleValidateRUT()
            setMovement((m: any) => {
                return {
                    ...m,
                    jsonMovement: {
                        ...(m.jsonMovement || {}),
                        rut: formatRut(m.jsonMovement.rut)
                    }
                };
            });

        }
    }
    const resetMovemenet = {
        ammount: 0, idMovement: 0, data: "Voucher PAX", idUser: 6559, idAccountPlan: 83024, dateTransaction: format(new Date(), "dd-MM-yyyy"),
        voucherStage: 0,
        jsonMovement: {
            rut: "", nombre: "", email: "", movil: "",
            dateProgram: "", dateStartSell: "", dateEndSell: "",
            status: "", stage: 0, idUser: 0, mercenaries: [], logs: [], idBooking: 0,
            obs: "para coordinar via e-mail club@planeadores.cl con un mínimo de 4 días de anticipación",
        }
    } as ItemsMovement
    useEffect(() => {
        setMovement(resetMovemenet);
    }, []);
    const handleRUTKeyDown = (event: { detail: { key: string } }) => {
        if (event.detail.key === 'Enter') {
            handleValidateRUT();
            // Your logic here
        }
    };

    const handleAddMovement = async () => {
        try {
            setLoading(true)
            let body = {
                ...movement,
                pax: true
            }
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/admin/movements/update',
                    'JWT': getCookie("JWT"),
                    //  
                },
                body: JSON.stringify(body),
                //mode: 'no-cors'  // Bypasses CORS but limits the response
            });
            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const data = await response.json();
            if (data.code == 0) {
                addNotification(data.status, 'info', setData);
                setMovement(resetMovemenet);
            } else {
                addNotification(data.status, 'error', setData);
            }
        } catch (error: any) {
            addNotification(`Error de red y/o comunicaciones3: ${error.message}`, 'error', setData);
        } finally { setLoading(false) }
    }

    const isDisabledMovement = (m: ItemsMovement): boolean => {
        const rut = m?.jsonMovement?.rut ?? "";
        if (rut === "") return true;
        if (!validateRut(rut)) return true;
        if (!m.jsonMovement.nombre || m?.jsonMovement?.nombre === "") return true
        if (!m.ammount || m?.ammount === 0) return true
        if (!m.jsonMovement.email || m?.jsonMovement?.email === "" || !isEmail(m?.jsonMovement?.email)) return true
        if (!m.jsonMovement.movil || m?.jsonMovement?.movil === "") return true
        if ((!m.jsonMovement.payment && !m.tbkCodAuto) || m?.jsonMovement?.payment === "CARD" && m?.tbkCodAuto?.length !== 6) return true
        return false;
    };
    const handleValidateRUT = async () => {
        if (!validateRut(movement?.jsonMovement?.rut ?? "")) {
            addNotification(data.status, "error", setData);
            return
        }
        const rutTemp = formatRut(movement?.jsonMovement?.rut)
        addNotification(data.status, "error", setData);;
        //setPendingJobCreation(true);
        try {
            setRutLoading(true)
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/admin/movements/haulmer/taxpayer',
                    'JWT': getCookie("JWT"),
                    //  
                },
                body: JSON.stringify({
                    RUT: rutTemp,
                }),
                //mode: 'no-cors'  // Bypasses CORS but limits the response
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const data = await response.json();
            addNotificationStatus(data, setData);
            if (data.code == 0) {

                setMovement((m: any) => {
                    // Safety check to ensure we aren't spreading null
                    //if (!m) return m;

                    return {
                        ...m,
                        jsonMovement: {
                            ...(m.jsonMovement || {}), // Handle case where jsonMovement might be null
                            nombre: data?.SII?.razonSocial ?? ""
                        }
                    };
                });

            }
        } catch (error: any) {
            addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
        } finally {
            //setPendingJobCreation(false);
            setRutLoading(false)
        }
    };
    return (
        <CustomAppLayout
            toolsHide
            contentType="form"
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <>
                    <SpaceBetween direction="vertical" size="xs">
                        <Header actions={<Favorites />} description={"Generar un ingreso a la cuenta Vuelo Pasajero para vuelo PAX"}
                        >
                            Generar Voucher
                        </Header>
                        <Form actions={<Button variant='primary' disabled={isDisabledMovement(movement)} onClick={() => {
                            handleAddMovement(); ////console.log(movement)
                        }}>
                            Generar
                        </Button>}>
                            <SpaceBetween direction="vertical" size="xs">
                                <Container header={<Header>Movimiento</Header>}>
                                    <SpaceBetween direction="vertical" size="xs">
                                        <SpaceBetween direction="horizontal" size="xs">
                                            <FormField label="Usuario">
                                                <SelectUser value={6559} readonly onConfirm={(user) => { }} />
                                            </FormField>

                                            <FormField label="Cuenta">
                                                <SelectAccountPlan value={83024} readonly />
                                            </FormField>
                                        </SpaceBetween>

                                        <div style={{ width: 400 }}>
                                            <FormField label="Observaciones">

                                                <Textarea value={movement?.jsonMovement?.obs ?? ""} onChange={(e) => {
                                                    setMovement((m: any) => {
                                                        return { ...m, jsonMovement: { ...(m.jsonMovement || ""), obs: e.detail.value } }
                                                    });

                                                }} />
                                            </FormField>
                                        </div>
                                        <FormField label={"Forma de pago"}>
                                            <RadioGroup value={movement?.jsonMovement?.payment ?? ""}
                                                onChange={(e) => {
                                                    setMovement((m: any) => {
                                                        return { ...m, jsonMovement: { ...(m.jsonMovement || {}), payment: e.detail.value } };
                                                    });
                                                }}
                                                items={[
                                                    { label: "Transferencia electrónica", value: "TRANSFER" },
                                                    { label: "Tarjetas bancarias", value: "CARD" },
                                                ]}
                                            />
                                        </FormField>
                                        <SpaceBetween direction="horizontal" size="xs">
                                            <FormField label={"Valor voucher"}>
                                                <CurrencyInput
                                                    disabled={!movement?.jsonMovement?.payment || movement?.jsonMovement?.payment === ""}
                                                    value={movement?.ammount ?? 0} onChange={(v) => {
                                                        setMovement((m: any) => { return { ...m, ammount: v } })
                                                    }}
                                                />

                                            </FormField>

                                            {movement?.jsonMovement?.payment === "CARD" && (
                                                <div style={{ width: 200 }}>
                                                    <FormField label={"Código de Autorización"} constraintText={"Transbank"}>

                                                        <Input value={movement?.tbkCodAuto ?? ""} onChange={(e) => {
                                                            if (e.detail.value.length > 6) return;
                                                            setMovement((m: any) => ({ ...m, tbkCodAuto: e.detail.value }))
                                                        }}
                                                        />
                                                    </FormField>
                                                </div>
                                            )}
                                        </SpaceBetween>
                                    </SpaceBetween>

                                </Container>

                                <Container header={<Header>Pasajero</Header>}>

                                    <SpaceBetween direction="vertical" size="xs">
                                        <SpaceBetween direction="horizontal" size="xs">
                                            <div style={{ width: 150 }}>
                                                <FormField label="RUT">
                                                    <Input
                                                        controlId='infoRUT'
                                                        value={movement?.jsonMovement?.rut ?? ""}
                                                        placeholder="12345678-9"
                                                        onChange={({ detail }) => {
                                                            const newValue = detail.value;
                                                            setMovement((m: any) => {
                                                                return {
                                                                    ...m,
                                                                    jsonMovement: {
                                                                        ...(m.jsonMovement || {}),
                                                                        rut: newValue
                                                                    }
                                                                };
                                                            });
                                                        }}
                                                        onKeyDown={handleRUTKeyDown}
                                                        autoComplete={false}
                                                        autoFocus
                                                        onBlur={handleRUTBlur}
                                                    />
                                                </FormField>
                                            </div>
                                            <div style={{ width: 400 }}>
                                                <FormField label="Nombre" info={
                                                    rutLoading ? <Spinner size="normal" /> : null
                                                }>
                                                    <Input
                                                        value={movement?.jsonMovement?.nombre ?? ""} onChange={(e) => {
                                                            setMovement((m: any) => {
                                                                return { ...m, jsonMovement: { ...(m.jsonMovement || {}), nombre: e.detail.value } };
                                                            });

                                                        }} />
                                                </FormField>
                                            </div>
                                        </SpaceBetween>
                                        <SpaceBetween direction="horizontal" size="xs">
                                            <div style={{ width: 150 }}>
                                                <FormField label="Móvil">
                                                    <PhoneInput value={movement?.jsonMovement?.movil ?? ""} width={150}
                                                        onChange={(phone) => {
                                                            setMovement((m: any) => {
                                                                return { ...m, jsonMovement: { ...(m.jsonMovement || {}), movil: phone } };
                                                            });
                                                        }}
                                                    />
                                                </FormField>
                                            </div>
                                            <div style={{ width: 400 }}>
                                                <FormField label="Email"
                                                    constraintText={
                                                        <Checkbox
                                                            disabled={!isEmail(movement?.jsonMovement?.email ?? "")}
                                                            checked={movement?.jsonMovement?.sendEmail ?? false} onChange={(e) => {
                                                                setMovement((m: any) => {
                                                                    return { ...m, jsonMovement: { ...(m.jsonMovement || {}), sendEmail: e.detail.checked } };
                                                                });
                                                            }}>
                                                            Enviar copia de voucher al correo del pasajero
                                                        </Checkbox>
                                                    }
                                                >
                                                    <Input value={movement?.jsonMovement?.email ?? ""} autoComplete={"off"} onChange={(e) => {
                                                        setMovement((m: any) => {
                                                            return { ...m, jsonMovement: { ...(m.jsonMovement || {}), email: e.detail.value.toLowerCase() } };
                                                        });

                                                    }} />
                                                </FormField>
                                            </div>
                                        </SpaceBetween>

                                    </SpaceBetween>

                                </Container>
                            </SpaceBetween>
                        </Form>



                    </SpaceBetween>


                </>
            }
        />
    );
};
